/* eslint-disable */
import _ from 'underscore';
import ko from 'knockout';
var i18n = window.globalLegacyI18n.get('component/i18n/loader!component/upgraded-url');
var ViewModel = function (data) {
  this.isFinalUrl = ko.observable(data.isFinal);
  this.isFinalUrl.Editing = ko.computed({
    read: function () {
      return this.isFinalUrl().toString();
    },
    write: function (newValue) {
      return this.isFinalUrl(newValue === 'true');
    }
  }, this);
  this.editMode = ko.observable(false);
};
export default ViewModel;

